import { UilCheck } from '@iconscout/react-unicons';
import { Dialog, Slide } from '@mui/material';
import { motion } from 'framer-motion';
import { forwardRef, useState } from 'react';
import { InlineWidget } from 'react-calendly';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const BookingPoint = ({ text }) => {
  return (
    <div className="flex flex-row place-items-center space-x-2">
      <UilCheck className="w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7" color="#0D5192" />
      <p className="text-sm sm:text-base lg:text-lg">{text}</p>
    </div>
  );
};

function Contact() {
  const [open, setOpen] = useState(false);

  const bookingPoints = [
    'Review our services',
    'Goals and expected outcomes',
    'Have your main challenges and pain points ready',
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <section
      id="Contact"
      className="pt-16 sm:pt-20 md:pt-24 lg:pt-28 h-[100vh] flex flex-col items-center bg-white font-primary bg"
    >

      <motion.div
        className="text-2xl xs:text-3xl md:text-4xl xl:text-5xl bg-white font-primary p-4 sm:p-6 md:p-8 xl:p-10 z-10 px-4 sm:px-6 lg:px-10 pt-4 sm:pt-6 lg:pt-10 pb-4 sm:pb-6 lg:pb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        Get in touch
      </motion.div>

      <motion.div
        className="relative text-center pb-4 sm:pb-6 lg:pb-8 text-sm sm:text-base lg:text-lg xl:text-xl text-gray-500 bg-white p-2 w-[90%] sm:w-[85%] md:w-[80%] lg:w-[70%] xl:w-[60%]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      >
        <h1>
          Email us to discuss your project, or ask us
          anything related to our services, content, or products.
        </h1>
        <p className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-[#0D5192] pt-2">
          admin@ar5labs.com
        </p>
      </motion.div>

      <motion.div
        className="w-[90%] max-w-[400px] sm:max-w-[430px] md:max-w-[460px] lg:max-w-[500px] xl:max-w-[550px] h-fit rounded-xl shadow-sm bg-gray-100 p-3 z-20 border-[#B7BCC5] px-3 sm:px-4 text-center"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="text-base sm:text-lg lg:text-xl p-2 py-2 lg:py-3 font-semibold">What to Prepare</p>
        <div className="flex flex-col p-2 lg:p-3 space-y-3 sm:space-y-4 lg:space-y-5 text-left">
          {bookingPoints.map((point, index) => (
            <BookingPoint key={index} text={point} />
          ))}
        </div>
      </motion.div>

      {/* <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          style: {
            height: '90vh',
            maxHeight: '800px',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '16px',
            overflow: 'hidden',
            margin: 'auto',
            position: 'relative',
          },
        }}
        aria-describedby="calendly-dialog"
      >
        <div className="bg-white border-b-2 border-gray-200 p-4">
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
            Book Your Session
          </h2>
        </div>

        <div
          style={{
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
          }}
        >
          <InlineWidget
            url="https://calendly.com/aymen-rumi-mail/30min"
            styles={{
              height: '100%',
              width: '100%',
              minHeight: '600px',
            }}
            pageSettings={{
              hideGdprBanner: true,
              primaryColor: '#0D5192',
            }}
          />
        </div>

        <div
          style={{
            padding: '16px',
            borderTop: '1px solid #ddd',
            textAlign: 'right',
            backgroundColor: 'white',
          }}
        >
          <motion.button
            onClick={handleClose}
            style={{
              padding: '10px 20px',
              backgroundColor: '#0D5192',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
            whileHover={{
              scale: 1.01,
              backgroundColor: '#073E72',
              boxShadow: '0 4px 20px rgba(13, 81, 146, 0.15)',
            }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 400, damping: 17 }}
          >
            Close
          </motion.button>
        </div>
      </Dialog> */}
    </section>
  );
}

export default Contact;
